import { useEffect, useRef } from "react";
import { authService } from "../services/auth.services";

const OnlyNumberAllow = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

const OnlyNumberLength = (e) => {
  var a = [];
  var k = e.which;

  if (!/[0-9]/.test(e.key)) {
    e.preventDefault();
  }

  for (let i = 48; i < 58; i++) a.push(i);

  if (!(a.indexOf(k) >= 0)) e.preventDefault();
};

const maxLengthCheck = (e) => {
  if (e.target.value <= 15) e.preventDefault();
};

const formatMoney = (number) => {
  if (!number) {
    return "0";
  }
  return number?.toLocaleString("en-in", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

const updateURLParameter = (url, queryParm) => {
  var tempArray = url !== undefined && url?.split("?");
  var baseURL = tempArray[0];
  if (queryParm !== undefined) {
    return baseURL + "?" + queryParm;
  } else {
    return baseURL;
  }
};

const removeParam = (key, sourceURL) => {
  var rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
};

const isEmptyObject = (obj) => {
  return JSON.stringify(obj) === "{}";
};

const checkLogin = async (navigate) => {
  const userToken = JSON.parse(localStorage.getItem("user"));
  if (userToken && userToken?.token) {
    await authService
      .checkLogin()
      .then(() => {})
      .catch((e) => {
        localStorage.clear();
        // navigate("/")
        navigate("/applicants");
      });
  } else {
    localStorage.clear();
    // navigate("/")
    navigate("/applicants");
  }
};

const unsecuredCopyToClipboard = (text) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    document.execCommand("copy");
  } catch (err) {
    console.error("Unable to copy to clipboard", err);
  }
  document.body.removeChild(textArea);
};

const useOuterClick = (callback) => {
  const innerRef = useRef();
  const callbackRef = useRef();
  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);

    function handleClick(e) {
      if (
        innerRef.current &&
        callbackRef.current &&
        !innerRef.current.contains(e.target)
      ) {
        callbackRef.current(e);
      }
    }
  }, []);

  return innerRef;
};

const capitalizeFirstLetter = (string) => {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    return "";
  }
};

const getHost = (ds) => {
  console.log("============================");
  const domain = ds.split(".")[1] + "." + ds.split(".")[2];
  const host = domain == "gloify.co" ? ds.split(".")[0] : ds.split(".")[1];
  return host;
};

export {
  OnlyNumberAllow,
  formatMoney,
  updateURLParameter,
  removeParam,
  isEmptyObject,
  checkLogin,
  unsecuredCopyToClipboard,
  useOuterClick,
  capitalizeFirstLetter,
  OnlyNumberLength,
  maxLengthCheck,
  getHost,
};
